import React from "react";
import { View } from "@amzn/stencil-react-components/layout";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { HeaderSkeleton } from "@amzn/it-shop-shared-components";

/**
 * Full-page skeleton placeholder shown while the app is loading.
 */
export const AppSkeleton: React.FC = () => {
  return (
    <>
      <HeaderSkeleton />
      <View padding="S700" aria-busy="true" aria-label="Loading application" data-testid="app-skeleton">
        <Spinner size={SpinnerSize.Medium} />
      </View>
    </>
  );
};
